import { render, staticRenderFns } from "./notice-tracking.vue?vue&type=template&id=0881519a&scoped=true&"
import script from "./notice-tracking.vue?vue&type=script&lang=js&"
export * from "./notice-tracking.vue?vue&type=script&lang=js&"
import style0 from "./notice-tracking.vue?vue&type=style&index=0&id=0881519a&prod&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0881519a",
  null
  
)

export default component.exports